export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-4 gap-8 mb-8">
            <div>
              <div className="flex items-center gap-3 mb-4">
                <img 
                  src="https://static.readdy.ai/image/97c320206ed08475f986f4f05d477848/5a6a5480219dadc71ff06553c0ed212f.webp" 
                  alt="Lino García Abogados" 
                  className="w-12 h-12"
                />
                <div>
                  <h3 className="text-xl font-bold">Lino García Abogados</h3>
                  <p className="text-sm text-gray-400">Especialistas en Extranjería</p>
                </div>
              </div>
              <p className="text-gray-400 mb-4">
                Abogado Colegiado ICAM Nº 138.891
              </p>
              <p className="text-gray-400">
                15+ años de experiencia en Derecho Migratorio
              </p>
            </div>

            <div>
              <h4 className="text-lg font-bold mb-4">Contacto</h4>
              <div className="space-y-3">
                <div className="flex items-start gap-2 text-gray-400">
                  <i className="ri-map-pin-fill text-xl mt-1"></i>
                  <div>
                    <p className="text-white font-semibold">Dirección</p>
                    <p>Calle de Castelló, 36, 1° A, Salamanca,</p>
                    <p>28001 Salamanca, Madrid-España</p>
                  </div>
                </div>
                <a 
                  href="mailto:linogarcia@extranjeria.abogado" 
                  className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors cursor-pointer"
                >
                  <i className="ri-mail-fill text-xl"></i>
                  <span>linogarcia@extranjeria.abogado</span>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-lg font-bold mb-4">Horario</h4>
              <div className="space-y-2 text-gray-400">
                <div className="flex items-start gap-2">
                  <i className="ri-time-fill text-xl mt-1"></i>
                  <div>
                    <p className="font-semibold text-white">Lunes a Viernes</p>
                    <p>9:30 a 13:30</p>
                    <p>18:30 a 20:30</p>
                  </div>
                </div>
                <div className="flex items-start gap-2 mt-3">
                  <i className="ri-time-fill text-xl mt-1"></i>
                  <div>
                    <p className="font-semibold text-white">Sábados</p>
                    <p>10:30 a 13:30</p>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <h4 className="text-lg font-bold mb-4">Síguenos</h4>
              <div className="flex flex-wrap gap-3 mb-6">
                <a 
                  href="https://extranjeria.abogado/" 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 flex items-center justify-center bg-gray-800 hover:bg-blue-600 rounded-full transition-colors cursor-pointer"
                  aria-label="Página Web"
                >
                  <i className="ri-global-line text-xl"></i>
                </a>
                <a 
                  href="https://www.facebook.com/lino.j.garcia" 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 flex items-center justify-center bg-gray-800 hover:bg-blue-600 rounded-full transition-colors cursor-pointer"
                  aria-label="Facebook"
                >
                  <i className="ri-facebook-fill text-xl"></i>
                </a>
                <a 
                  href="https://www.instagram.com/extranjeria.abogado/" 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 flex items-center justify-center bg-gray-800 hover:bg-pink-600 rounded-full transition-colors cursor-pointer"
                  aria-label="Instagram"
                >
                  <i className="ri-instagram-fill text-xl"></i>
                </a>
                <a 
                  href="https://www.tiktok.com/@extranjeria.abogado" 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 flex items-center justify-center bg-gray-800 hover:bg-black rounded-full transition-colors cursor-pointer"
                  aria-label="TikTok"
                >
                  <i className="ri-tiktok-fill text-xl"></i>
                </a>
                <a 
                  href="https://www.linkedin.com/in/abogadolinogarcia" 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 flex items-center justify-center bg-gray-800 hover:bg-blue-700 rounded-full transition-colors cursor-pointer"
                  aria-label="LinkedIn"
                >
                  <i className="ri-linkedin-fill text-xl"></i>
                </a>
                <a 
                  href="https://www.youtube.com/channel/UCyK8OgmAKgQJkRTcuCrMk7g" 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 flex items-center justify-center bg-gray-800 hover:bg-red-600 rounded-full transition-colors cursor-pointer"
                  aria-label="YouTube"
                >
                  <i className="ri-youtube-fill text-xl"></i>
                </a>
              </div>
              <h4 className="text-lg font-bold mb-4">Enlaces Rápidos</h4>
              <div className="space-y-2">
                <a href="#requisitos" className="block text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Recomendaciones
                </a>
                <a href="#consulta" className="block text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Reservar Consulta
                </a>
              </div>
            </div>
          </div>

          <div className="border-t border-gray-800 pt-8 text-center">
            <p className="text-gray-400 mb-4">
              © {new Date().getFullYear()} Lino García Abogados. Todos los derechos reservados.
            </p>
            <div className="flex justify-center items-center gap-2 text-sm text-gray-500">
              <span>Powered by</span>
              <a 
                href="https://readdy.ai/?origin=logo" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-blue-400 hover:text-blue-300 transition-colors cursor-pointer"
              >
                Lino García
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
